import CarouselSnapped from './carousel-snapped';

export default CarouselSnapped;
